// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".doh[data-v-4110b1f0]{background:linear-gradient(90deg,rgba(73,74,98,.3),rgba(108,111,157,.2));border-radius:10px;padding-top:10px;padding-left:35px;box-sizing:border-box}.doh h2[data-v-4110b1f0]{color:#f1edff;font-family:YouSheBiaoTiHei;font-size:24px;height:31px;text-align:left;text-shadow:0 2px 20px #2a38b4}.box[data-v-4110b1f0]{width:360px;height:180px}", ""]);
// Exports
module.exports = exports;
